import { render, staticRenderFns } from "./CollaboratorePage.vue?vue&type=template&id=2cb96225"
import script from "./CollaboratorePage.vue?vue&type=script&lang=js"
export * from "./CollaboratorePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports